(function($){

  // Accessibility: Slick a11y reorder/focus helpers moved to assets/accessibility-plugin.js (4.7.0).

  
//   function pagination() {
//   var offset = $(document).scrollTop();
//   var windowHeight = $(window).height();
//   var $body = $('body');
//   var padding = .75;
//   var pages = Object.keys($('.scroll-content')).filter((section) => Number(section) + 1).map(section => Number(section) + 1)

//   pages.map((page) => {
//     if (offset > (windowHeight * (page - 2 + padding))) {
//        $body.removeClass().addClass("page-" + page);
//     }
//   });
// };

// pagination();
//   $(document).on('scroll', pagination);

//   $(document).on('scroll', function() {
//     $('.scroll-content-wrap .scroll-content').each(function(index, element) {
//         if ($(window).scrollTop() > $(element).offset().top) {
//             $(element).addClass('scrolled');
//         } else {
//             $(element).removeClass('scrolled');
//         }
//     });
// });


const myDemo = (function () {
  const init = function () {
    createObserver();
  };

  const createObserver = function () {
    let options = {
      root: null,
      rootMargin: "10px",
      threshold: 0.35
    };

    let observer = new IntersectionObserver(
      function (entries, observer) {
          handleIntersect(entries, observer); 
        }, 
      options);
    
    let targetElements = document.querySelectorAll('.scroll-content');
   
    
  

    targetElements.forEach((targetElement) => {
      observer.observe(targetElement);
      
    });
  };

  const handleIntersect = function (entries, observer) {
    let currentPageNum = document.getElementById('current-page');
     let targetParents = document.getElementById('target');
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
       currentPageNum.innerHTML =  entry.target.attributes.getNamedItem("data-page-number").value;
        targetParents.classList.add("fixed");
       // console.log('intersecting');
      //  currentPageNum.innerHTML = 'hello';
        //observer.unobserve(entry.target);
      console.log(entry.target.id)
        if(entry.target.id == 'last'){
          //  $('body').removeClass('scroll-hi')+
          // $('#target').removeClass('scroll-to-fixed-fixed')
          // $('#target').css('position','relative');
        }
        else{
          // $('body').addClass('scroll-hi')+
          // $('#target').addClass('scroll-to-fixed-fixed')
          // $('#target').css('position','absolute');
        }
      }
      
    });
  };

  return {
    init: init
  };
})();

myDemo.init();

// var swiper = new Swiper(".mySwiper", {
//       direction: "vertical",
//       slidesPerView: 1,
//       spaceBetween: 0,
//       mousewheel: true,
//       pagination: {
//         el: ".swiper-pagination",
//         type: "fraction",
//       },
//     });


// $(window).scroll(function(){
//    if ($("#target").hasClass("scroll-to-fixed-fixed")) {
//           $('body').addClass('scroll-hi')
//         }
//   else{
//       $('body').removeClass('scroll-hi')
//   }
//   });


  
    $(document).ready(function() {
       // $('#target').scrollToFixed({
       //    marginTop: $('.header_wrap').outerHeight(true) + 50,
       //      limit: $('.bacio-sign-wrap2').offset().top
       //  });

     
  
           var savedScrollPosition = 0;
           $('.menu-btn>button').click(function(){
            savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
         $('body').addClass('no-scroll');
        $('.mobile-menu').addClass('active');
        $(this).attr('aria-expanded', 'true');
       })	
       $('.menu-close>a').click(function(){
         $('body').removeClass('no-scroll');
        $('.mobile-menu').removeClass('active');
        window.scrollTo(0, savedScrollPosition);
        $('.menu-btn>button').attr('aria-expanded', 'false');
       })	
  
        $('.mobile-menu-link li a').on('click', function(){
                 var target = $(this).attr('data-rel');
              $('.mobile-menu-link li a').removeClass('active');
                 $(this).addClass('active');
                 $("#"+target).fadeIn('slow').siblings(".megamenu").hide();
                 return false;
    });
  
      $('.nav_element').mouseover(function() {
            $(this).addClass('active');
            $('.main-menu').addClass('blur');
              });
      $('.nav_element').mouseout(function() {
            $(this).removeClass('active');
            $('.main-menu').removeClass('blur');
              });

      $('.nav_element > .nav-toggle').on('click keydown', function(e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        if (e.type === 'keydown') e.preventDefault();
        var $navEl = $(this).closest('.nav_element');
        var isOpen = $navEl.hasClass('open');
        $('.nav_element').removeClass('open active');
        $('.nav_element > .nav-toggle').attr('aria-expanded', 'false');
        if (!isOpen) {
          $navEl.addClass('open active');
          $navEl.find('> .nav-toggle').attr('aria-expanded', 'true');
          $('.main-menu').addClass('blur');
          $navEl.find('.megamenu a, .megamenu button').first().focus();
        } else {
          $('.main-menu').removeClass('blur');
        }
      });

      // Close a pinned-open megamenu when Tab (or other focus moves) leaves that top-level item.
      // Clicks outside are handled separately; keyboard users can move focus to logo / search / cart
      // without a click, so the panel would otherwise stay .open (e.g. last megamenu: SCIENCE).
      $('.nav_element').on('focusout', function () {
        var el = this;
        setTimeout(function () {
          if (!el.contains(document.activeElement)) {
            var $navEl = $(el);
            if ($navEl.hasClass('open')) {
              $navEl.removeClass('open active');
              $navEl.find('> .nav-toggle').attr('aria-expanded', 'false');
              if (!$('.nav_element.open').length) {
                $('.main-menu').removeClass('blur');
              }
            }
          }
        }, 0);
      });

      $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
          var $openNav = $('.nav_element.open');
          if ($openNav.length) {
            $openNav.find('> .nav-toggle').attr('aria-expanded', 'false').focus();
            $openNav.removeClass('open active');
            $('.main-menu').removeClass('blur');
          }
        }
      });

      $(document).on('click', function(e) {
        if (!$(e.target).closest('.nav_element').length) {
          $('.nav_element').removeClass('open active');
          $('.nav_element > .nav-toggle').attr('aria-expanded', 'false');
          $('.main-menu').removeClass('blur');
        }
      });

      window.initialScrollPosition = 0;
      console.log("initialScrollPosition scripts", window.initialScrollPosition);

      $('.cart-icon').click(function () {
        window.initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        console.log("changed ScrollPosition scripts", window.initialScrollPosition);
        $('body').addClass('mobile-no-scroll');
        $('.side-cart').addClass('active', 250);
      })

      $('#cart').click(function () {
        window.initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        console.log("changed ScrollPosition scripts", window.initialScrollPosition);
        $('body').addClass('mobile-no-scroll');
        $('.side-cart').addClass('active', 250);
      })

      $('#cart2').click(function () {
        window.initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        console.log("changed ScrollPosition scripts", window.initialScrollPosition);
        $('body').addClass('mobile-no-scroll');
        $('.side-cart').addClass('active', 250);
      })

      $('#cart4').click(function () {
        window.initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        console.log("changed ScrollPosition scripts", window.initialScrollPosition);
        $('body').addClass('mobile-no-scroll');
        $('.side-cart').addClass('active', 250);
      })

      $('.close-cart').click(function () {
        console.log("close cart scripts.js fired");
        $('body').removeClass('mobile-no-scroll');
        $('.side-cart').removeClass('active', 250);
        // Temporarily disable smooth scrolling
        document.documentElement.style.scrollBehavior = 'auto';
        document.body.style.scrollBehavior = 'auto';

        document.documentElement.scrollTop = window.initialScrollPosition;
        document.body.scrollTop = window.initialScrollPosition;

        // Re-enable smooth scrolling after a brief delay
        setTimeout(() => {
          document.documentElement.style.scrollBehavior = '';
          document.body.style.scrollBehavior = '';
        }, 100);
      })	
      
      $('.layer14').on('click', function(e) {
                  
                  e.preventDefault(); // prevent hard jump, the default behavior
                  var target = $(this).attr("href"); // Set the target as variable
                  console.log(target);
          
                  $('html, body').stop().animate({
                          scrollTop: $(target).offset().top - 180
                  }, 600, function() {
                          //location.hash = target; //attach the hash (#jumptarget) to the pageurl
                          console.log($(target).offset().top);
                  });
  
                  return false;				
          });
       $('.layer145').on('click', function(e) {
                  
                  e.preventDefault(); // prevent hard jump, the default behavior
                  var target = $(this).attr("href"); // Set the target as variable
                  console.log(target);
          
                  $('html, body').stop().animate({
                          scrollTop: $(target).offset().top - 120
                  }, 600, function() {
                          //location.hash = target; //attach the hash (#jumptarget) to the pageurl
                          console.log($(target).offset().top);
                  });
  
                  return false;				
          });
      $('.down-btn').on('click', function(e) {
                  
                  e.preventDefault(); // prevent hard jump, the default behavior
                  var target = $(this).attr("href"); // Set the target as variable
                  console.log(target);
          
                  $('html, body').stop().animate({
                          scrollTop: $(target).offset().top - 180
                  }, 600, function() {
                          //location.hash = target; //attach the hash (#jumptarget) to the pageurl
                          console.log($(target).offset().top);
                  });
  
                  return false;				
          });

      $('.faq-list li a').on('click', function(e) {
                  
                  e.preventDefault(); // prevent hard jump, the default behavior
                  var target = $(this).attr("href"); // Set the target as variable
                  console.log(target);
          
                  $('html, body').stop().animate({
                          scrollTop: $(target).offset().top - 180
                  }, 600, function() {
                          //location.hash = target; //attach the hash (#jumptarget) to the pageurl
                          console.log($(target).offset().top);
                  });
  
                  return false;				
          });
     
      
   $('.hero-slider').slick({
     accessibility: true,
      dots: true,
      infinite: true,
      arrows:false,
     //fade:true,
      slidesToShow: 1,
     // asNavFor: '.ab-industry-nav',
      slidesToScroll: 1
    });
  
    //   $('.ab-industry-nav').slick({
    //   dots: false,
    //   infinite: true,
    //   arrows:false,
    
    //     asNavFor: '.hero-slider',
    //   slidesToShow: 1,
    //   slidesToScroll: 1
    // });
      
      // $('#slider').layerSlider({
      //   sliderVersion: '6.0.0',
      //   type: 'fullsize',
      //   responsiveUnder: 1,
      //   layersContainer: 1600,
      //   maxRatio: 1,
      //   parallaxScrollReverse: true,
      //   hideUnder: 0,
      //   hideOver: 100000,
      //   skin: 'v6',
      //   allowRestartOnResize: true,
      //   thumbnailNavigation: 'disabled',
      //   skinsPath: '../../layerslider/skins/',
      //   height: 1048
      // });
  
      // $('#slider2').layerSlider({
      //   sliderVersion: '6.0.0',
      //   type: 'fullsize',
      //   responsiveUnder: 1,
      //   layersContainer: 375,
      //   maxRatio: 1,
      //   parallaxScrollReverse: true,
      //   hideUnder: 0,
      //   hideOver: 100000,
      //   skin: 'v6',
      //   allowRestartOnResize: true,
      //   thumbnailNavigation: 'disabled',
      //   skinsPath: '../../layerslider/skins/',
      //   height: 741
      // });
  
     
       
  
  
  
  
    $('.a-what-new-slide').each(function () {
      var $slideRoot = $(this);
      if ($slideRoot.hasClass('slick-initialized')) return;

      var $prev;
      var $next;
      var ntEl = document.getElementById('newestTerpenes');
      if (ntEl && ntEl.contains($slideRoot[0])) {
        $prev = $('#newestTerpenes').prev('.container').find('.custom-arrow .prev').first();
        $next = $('#newestTerpenes').prev('.container').find('.custom-arrow .next').first();
      } else {
        var $scope = $slideRoot.closest('.ab-yellow-wrap, .shopify-section, [id^="shopify-section"]');
        $prev = $scope.find('.custom-arrow .prev, .a-what-new-head .prev').first();
        $next = $scope.find('.custom-arrow .next, .a-what-new-head .next').first();
      }
      if (!$prev.length) {
        $prev = $('.prev').first();
      }
      if (!$next.length) {
        $next = $('.next').first();
      }

      if (typeof window.abstraxBindNewestTerpenesCarouselDomReorder === 'function') {
        window.abstraxBindNewestTerpenesCarouselDomReorder($slideRoot);
      }

      $slideRoot.slick({
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        prevArrow: $prev,
        nextArrow: $next,
        centerPadding: '370px',
        accessibility: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '221px',
              accessibility: false,
              draggable: false,
              swipe: false,
              touchMove: false
            }
          },
          {
            breakpoint: 1605,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '221px',
              accessibility: false,
              draggable: false,
              swipe: false,
              touchMove: false
            }
          },
          {
            breakpoint: 1578,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '140px',
              accessibility: false,
              draggable: false,
              swipe: false,
              touchMove: false
            }
          },
          {
            breakpoint: 1410,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '20px'
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '20px',
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              centerPadding: '0',
              slidesToScroll: 1,
              accessibility: true,
              draggable: true,
              swipe: true,
              touchMove: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              slidesToScroll: 1,
              accessibility: true,
              draggable: true,
              swipe: true,
              touchMove: true
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              centerPadding: '0',
              slidesToScroll: 2,
              accessibility: true,
              infinite: true,
              draggable: true,
              swipe: true,
              touchMove: true
            }
          }
        ]
      });
    });

          $('.custom-slide-2').slick({
      dots: false,
      infinite: false,
      arrows:true,
      speed: 300,
         centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      // prevArrow: $('.prevb'),
      // nextArrow: $('.nextb'),
      prevArrow:"<button type='button' class='prev '><img src='https://cdn.shopify.com/s/files/1/0743/6337/1815/files/prev-arrow.svg?v=1753720289'></button>",
      nextArrow:"<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/0743/6337/1815/files/next-arrow.svg?v=1753720278'></button>",
      
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '221px',
          }
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll:3,
            centerMode: false,
           centerPadding: '221px',
          }
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '140px',
          }
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '20px',
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
              initialSlide: 1,
            centerMode: false,
            centerPadding: '20px',
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
              initialSlide: 1,
            centerMode: false,
            arrows:true,
            centerPadding: '40px',
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
              initialSlide: 1,
            centerMode: false,
            arrows:true,
            centerPadding: '0px',
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
              initialSlide: 1,
            infinite: true,
            centerMode: true,
            arrows:true,
            centerPadding: '0px',
            slidesToScroll: 2
          }
        }
      ]
    });

    $('.tile-features-slider-mobile').each(function() {
      var $slider = $(this);
      
      function initTileSlider() {
        if (window.innerWidth < 750) {
          if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
              dots: false,
              infinite: false,
              arrows: true,
              speed: 300,
              centerMode: false,
              variableWidth: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow: "<button type='button' class='slick-next'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.292893 9.26953C-0.0976311 8.87901 -0.0976311 8.24502 0.292893 7.85449L8.14739 0L9.56242 1.41406L2.41399 8.5625L9.56242 15.71L8.14739 17.124L0.292893 9.26953Z' fill='#1C1C1E'/></svg></button>",
              nextArrow: "<button type='button' class='slick-prev'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9.26961 7.85449C9.66013 8.24502 9.66013 8.87901 9.26961 9.26953L1.41511 17.124L7.53403e-05 15.71L7.14851 8.56152L7.53403e-05 1.41406L1.41511 0L9.26961 7.85449Z' fill='#1C1C1E'/></svg></button>"
              
            });
          }
        } else {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
          }
        }
      }
      
      initTileSlider();
      
      var resizeTimer;
      $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          initTileSlider();
        }, 250);
      });
    });

    //    $('.custom-slide').slick({
    //   dots: false,
    //   infinite: true,
    //   arrows:true,
    //   speed: 300,
    //      centerMode: true,
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   prevArrow: $('.prevb'),
    //   nextArrow: $('.nextb'),
    //   centerPadding: '222px',
    //   responsive: [
    //     {
    //       breakpoint: 1900,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3,
    //         centerMode: true,
    //        centerPadding: '221px',
    //       }
    //     },
    //     {
    //       breakpoint: 1605,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll:3,
    //         centerMode: true,
    //        centerPadding: '221px',
    //       }
    //     },
    //     {
    //       breakpoint: 1578,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3,
    //         centerMode: true,
    //        centerPadding: '140px',
    //       }
    //     },
    //     {
    //       breakpoint: 1410,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3,
    //         centerMode: true,
    //        centerPadding: '20px',
    //       }
    //     },
    //     {
    //       breakpoint: 1200,
    //       settings: {
    //         slidesToShow: 2,
    //         centerMode: true,
    //         centerPadding: '20px',
    //         slidesToScroll: 2
    //       }
    //     },
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 2,
    //         centerMode: true,
    //         arrows:false,
    //         centerPadding: '40px',
    //         slidesToScroll: 2
    //       }
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 2,
    //         centerMode: true,
    //         arrows:false,
    //         centerPadding: '0px',
    //         slidesToScroll: 1
    //       }
    //     },
    //     {
    //       breakpoint: 640,
    //       settings: {
    //         slidesToShow: 1,
    //         centerMode: true,
    //         arrows:false,
    //         centerPadding: '100px',
    //         slidesToScroll: 1
    //       }
    //     }
    //   ]
    // });

           $('.custom-slide').slick({
      dots: false,
      infinite: false,
      arrows:true,
      speed: 300,
         centerMode: false,
             
      slidesToShow: 3,
      slidesToScroll: 3,
  prevArrow:"<button type='button' class='prev '><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(1 24.706) rotate(-90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/></g></svg></button>",
  nextArrow:"<button type='button' class='next'><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(13.06 1.414) rotate(90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/> </g> </svg></button>",
     
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '221px',
          }
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll:3,
            centerMode: false,
           centerPadding: '221px',
          }
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '140px',
          }
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
           centerPadding: '20px',
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '20px',
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            arrows:true,
            centerPadding: '40px',
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            arrows:true,
            centerPadding: '0px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
   infinite: true,
            arrows:true,
            centerPadding: '60px',
            slidesToScroll: 1
          }
        }
      ]
    });
     
  if ($(window).width() > 768) {
      $('.other-pro-head .nextb').trigger("click");
       $('.ab-other-wrap .custom-arrow .nextb').trigger("click");
  }
   });

if (window.innerWidth < 992) {
  
    

   
     $(".filter-quick>a").on("click", function () {
    $(this).parents().find('.collection-filters-form .Collapsible').toggle(500);
     $(this).parents().find('.collection-filters-form .Collapsiblea').toggle(500);
    $(this).toggleClass('open');
  })
  $('.Collapsible__Content li label, .Popover__Value').on("click", function () {
    $(".filter-quick>a").removeClass('open');
  })

    }
            
  $('.footer-link .h3').click(function(){
    $(this).toggleClass('active', 500);
    $(this).next('.show-m').toggle(500);
  })
  
  
  $('.h-blog-slide').slick({
    dots: true,
    infinite: true,
    arrows:true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: true,
    prevArrow: $('.prevb'),
    nextArrow: $('.nextb'),
    centerPadding: '300px',
    responsive: [
      {
        breakpoint: 1602,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
         centerPadding: '215px',
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
         centerPadding: '150px',
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          centerMode: true,
          centerMode: true,
         centerPadding: '50px',
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          arrows:false,
         centerPadding: '10px',
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $(document).ready(function() {
  
   
    $('.h-blog-slides').slick({
    dots: false,
    infinite: true,
    arrows:true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 2,
    centerMode: true,
    prevArrow: $('.prevb'),
    nextArrow: $('.nextb'),
    centerPadding: '300px',
    responsive: [
      {
        breakpoint: 1602,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          centerMode: true,
         centerPadding: '215px',
        }
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true,
         centerPadding: '150px',
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          centerMode: true,
          arrows:false,
          
         centerPadding: '50px',
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          arrows:false,
         centerPadding: '36px',
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
    $('.categories_slide').on('init reInit breakpoint', function (event, slick) {
      var $root = slick && slick.$slider ? $(slick.$slider) : $(this);
      if (typeof window.abstraxScheduleReorderCategoriesSlideArrows === 'function') {
        window.abstraxScheduleReorderCategoriesSlideArrows($root);
      }
    });

     $('.categories_slide').slick({
      dots: false,
      infinite: false,
      arrows:true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      // prevArrow: $('.prev'),
      // nextArrow: $('.next'),
      prevArrow:"<button type='button' class='prev '><img src='https://cdn.shopify.com/s/files/1/0743/6337/1815/files/prev-arrow.svg?v=1753720289'></button>",
      nextArrow:"<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/0743/6337/1815/files/next-arrow.svg?v=1753720278'></button>",
      centerPadding: '300px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
           centerPadding: '229px',
          }
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
           centerPadding: '229px',
          }
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
           centerPadding: '140px',
          }
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
           centerPadding: '80px',
          }
        },
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows:false,
            centerPadding: '40px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            arrows:false,
            centerPadding: '0px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows:false,
            centerPadding: '110px',
            slidesToScroll: 1
          }
        }
        // {
        //   breakpoint: 767,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     arrows:false,
        //     centerPadding: '120px',
        //     slidesToScroll: 1
        //   }
        // },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        // {
        //   breakpoint: 640,
        //   settings: {
        //     slidesToShow: 1,
        //     arrows:false,
        //     centerMode: true,
        //     centerPadding: '120px',
        //     slidesToScroll: 1
        //   }
        // }
      ]
    });
  
  
    
   });
    $('.single-blog .img a').each(function(){
    $(this).find('img:first').hide();
    var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img:first').hide();
  }); 
  
    $('.single-case-studies .img a').each(function(){
    $(this).find('img:first').hide();
    var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img:first').hide();
  }); 
  $('.single-media .img').each(function(){
    $(this).find('img:first').hide();
    var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img:first').hide();
  }); 
  
    $('.article-template-banner').each(function(){
    $(this).find('img:first').hide();
    var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img:first').hide();
  }); 
  
      jQuery('.video').parent().click(function () {
      if ($(this).children(".video").get(0).paused) {
          $(this).children(".video").get(0).play(); $(this).children(".playpause").fadeOut();
      } else {
          $(this).children(".video").get(0).pause();
          $(this).children(".playpause").fadeIn();
      }
  });
    
  
   
      $(document).on('click', '.qty-flex .qty', function(event) {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.hasClass("qty-plus")) {
        var newVal = parseFloat(oldValue) + 1;
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 0;
        }
    }

    $button.parent().parent().find("input").val(newVal);
});

  document.addEventListener("DOMContentLoaded", function () {
if ($(window).width() >= 640) {
    const createSVG = (width, height, radius) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  
    const rectangle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );
  
    svg.setAttributeNS(
      "http://www.w3.org/2000/svg",
      "viewBox",
      `0 0 ${width} ${height}`
    );
  
    rectangle.setAttribute("x", "0");
    rectangle.setAttribute("y", "0");
    rectangle.setAttribute("width", "100%");
    rectangle.setAttribute("height", "100%");
    rectangle.setAttribute("rx", `${radius}`);
    rectangle.setAttribute("ry", `${radius}`);
    rectangle.setAttribute("pathLength", "10");
  
    svg.appendChild(rectangle);
  
    return svg;
  };
  
  document.querySelectorAll(".btn-primary").forEach((button) => {
    const style = getComputedStyle(button);
  
    const lines = document.createElement("div");
  
    lines.classList.add("lines");
  
    const groupTop = document.createElement("div");
    const groupBottom = document.createElement("div");
  
    const svg = createSVG(
      button.offsetWidth,
      button.offsetHeight,
      parseInt(style.borderRadius, 10)
    );
  
    groupTop.appendChild(svg);
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
  
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
  
    lines.appendChild(groupTop);
    lines.appendChild(groupBottom);
  
    button.appendChild(lines);
  
    button.addEventListener("pointerenter", () => {
      button.classList.add("start");
    });
  
    svg.addEventListener("animationend", () => {
      button.classList.remove("start");
    });
  });
}
      });
  
    $('.product-slide').slick({
      dots: true,
      infinite: false,
      arrows:true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:"<button type='button' class='prev '><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(1 24.706) rotate(-90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/></g></svg></button>",
      nextArrow:"<button type='button' class='next'><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(13.06 1.414) rotate(90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/> </g> </svg></button>",
    
  
    });
  
//  window.onload = function(){
   
// };
  $(document).ready(function() {
      $('ul.accordion').accordion();

      // Keep aria-expanded in sync with the accordion plugin's open/close state.
      // The plugin doesn't manage ARIA itself, so we delegate on the anchor and
      // read the actual visibility of the sibling content panel after it runs.
      $(document).on('click', 'ul.accordion li > a', function () {
        var $trigger = $(this);
        setTimeout(function () {
          var isOpen = $trigger.next('div').is(':visible');
          $trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
          // Collapse ARIA state on all other triggers in the same accordion
          $trigger.closest('ul.accordion').find('li > a').not($trigger).attr('aria-expanded', 'false');
        }, 0);
      });
  });
   $(window).load(function(){
        
                  $('.collection-faq-wrap .accordion li a').eq(0).trigger('click');
                  $('.pro-specifications .accordion li a').eq(0).trigger('click');
                   $('.sample-aaplication-faq .accordion li a').eq(0).trigger('click');
     $('.pro-faq-wrap .accordion li a').eq(0).trigger('click');
     $('.at-faq-content .accordion li a').eq(0).trigger('click');
              });
  
  
  
  $(document).on("scroll", function(){
    var featHeight = $('.ab-product-wrap').height();
      setTimeout(function(){
        if($(document).scrollTop() > featHeight){
          $(".sticky_cart").addClass("fixed");
        }
      else{
          $(".sticky_cart").removeClass("fixed");
        }
      },300)
    });

      // Accessibility: sticky_cart tab-order exclusion moved to assets/accessibility-plugin.js (4.7.0).

  
    $(document).ready(function(){
      $('.product2-des .select-dropdown__button').click(function(){
        $(this).parents('.swatch').toggleClass("active");
        $(this).parents('body').toggleClass("activew");
        $(this).parents('.swatch').siblings().removeClass("active");
    });
  
  
    $(".blal").click(function(){
       var valu = $(this).attr('data-value');
       $(this).parent('.select-dropdown__list-item').parent('.select-dropdown__list').parent('.select-dropdown-pro').find('.spentxt').html(valu);
       $(this).parent('.select-dropdown__list-item').parent('.select-dropdown__list').removeClass("active");
       $(this).parents().find('.swatch').removeClass('active');
      console.log('---SELECT VALUE----',valu);
  });
  });
  
    //  $(".blal ").click(function() {
    //   $(this).closest('.select-dropdown').find('.select-dropdown__button span').text($(this).text());
    // });
  $(document).ready(function () {
      $(document).keydown(function(e){
  
          if(e.keyCode == 27) {
             $('.swatch ').removeClass('active');
            $('body').removeClass("activew");
          }
      });
  });
   $(document).mouseup(function(e) 
  {
      var container = $(".swatch");
  
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
        $('.swatch').removeClass('active');
            $('body').removeClass("activew");
      }
  });
  
  
    $('.toggle, .reg-toggle').click(function(){
      $('.product2-right').toggleClass('active');
      if ($('.product2-right').hasClass('active')) {
    $('.toggle span').text("Collapse");  // Show "Less" when expanded
  } else {
    $('.toggle span').text("Expand");  // Show "More" when collapsed
  }
    })
  
  //     $(document).on('click', '.collapse-headers', function(){
  //   $(this).toggleClass('active');
  //   $(this).next('.collapse-items').toggleClass('show');
  // });
  


  $("body").on(
    "click",
    ".collection-filters-form .Collapsible .collapse-headers",
    function () {
      $(this).toggleClass("active");
      $(this).parent(".Collapsible").toggleClass("active");
      // $(this).parents('body').toggleClass("activew");
      $(this).parent(".Collapsible").siblings().removeClass("active");
      $(this).parent(".Collapsible").siblings().children('.collapse-headers').removeClass("active");
    }
  );
  // $(document).on('click', '.collection-filters-form .Collapsible   .collapse-headers', function(){
  //     $(this).parents('.Collapsible').toggleClass("active");
  //     $(this).parents('body').toggleClass("activew");
  //     $(this).parents('.Collapsible').siblings().removeClass("active");
  // });
  
     $(document).mouseup(function(e) 
  {
      var container = $(".Collapsible");
  
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
        $('.Collapsible').removeClass('active');
         $('.collapse-headers').removeClass("active");
            $('body').removeClass("activew");
      }
  });


  
     $(".select-toggle").click(function (event) {
      event.stopPropagation();
    $(this).next(".dropdown-menu").toggleClass("active"), $(this).toggleClass("active-menu");
        $(".Collapsible").removeClass("active");
        $('.collapse-headers').removeClass("active");
}),
     
        $(".select-dropdown .dropdown-menu a").on("click", function () {
        var getValue = $(this).text();
        $(".select-dropdown .dropdown-menu>a").removeClass("active"), $(this).addClass("active"), $(".select-dropdown .dropdown-menu").removeClass("active");
    }),

   $(".select-dropdown .dropdown-menu a ").click(function () {
        $(this).closest(".select-dropdown").find(".select-toggle .text ").text($(this).text());
    }),
       
    $("body").click(function () {
        $(".select-dropdown .dropdown-menu").removeClass("active");
      $(".select-toggle").removeClass("active-menu");
      
    }),
    $(".select-toggle").click(function (event) {
        event.stopPropagation();
    });





    $('.radiobutt li label').on('click', function() {
    var getValue2 = $(this).text();

  });

   $("body").on("click",".radiobutt li label",function () {
  
    var imgsrc = $(this).find('img').attr("src")
    $(this).closest('.col-new').find('.collapse-headers .img').attr("src", imgsrc);
    $(this).closest('.col-new').find('.collapse-headers span k').text($(this).text());
    $('.collapse-headers').removeClass("active");
    $(this).parents(".Collapsible").removeClass("active");
  });
  
  
  
  //   $('input#Search-In-Modal-1').keyup(function() {
  //      if($(this).val().length > 1) {
  //         $('body').addClass("width-100");
    
  //     } else {
  //        $('body').removeClass("width-100");
  //     }
  // });
    $(".search-icon").click(function () {
    $(".desk-search_wrap").addClass("active"),
      setTimeout(function () {
        
        $("#goal-input").focus();
        $(".Search__Input").focus();
      }, 500);
       
    $('body').addClass('no-scroll');
    }),
      
    $('.search-i').click(function(){
    $('.desk-search_wrap').removeClass('active');
    $('body').removeClass('no-scroll');
      $('.header__search details').removeAttr("open");
      $('input[type="search"]').val('');
      $('.Search__Results').attr('aria-hidden', 'true'); // hide results
    })
    
    // $('.modal__close-button').click(function(){
    //   $('body').removeClass("width-100");
    //    $('input.search__input[type="search"]').val('');
    //  $(".search-modal__form").removeAttr("open");
    // }) 
  
    $(window).scroll(function(){
    var sticky = $('.header_wrap'),
        scroll = $(window).scrollTop();
  
    if (scroll >= 50) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });
  
  
    $('.mobile-show-f .link').click(function() {
    $('.faq-list').toggleClass('more', 500);
    if ($('.mobile-show-f .link').text() == "MORE FILTERS") {
      $(this).text("CLOSE FILTERS")
    } else {
      $(this).text("MORE FILTERS")
    }
  });
  
  $('a.link.read-bio, a.link.hide-bio').on('click', function() {
    $(this).closest('.meet-team-row').toggleClass('show-bio');
  });


  
        // $(document).ready(function(){
        //       $(".accordion-titel").click(function(){
        //       $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
        //       $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
        //       $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
        //       });
        //   });
  
  //   $(document).ready(function() {
  // 	$('.accordion-item').on('click', '.accordion-titel', function() {
  // 		$('.accordion-contant').slideUp().removeClass('flipInX');
  // 		$('.accordion-titel').removeClass('fa-minus');
  // 		if($(this).next().is(':hidden')) {
  // 			$(this).next().slideDown().addClass('flipInX');
  // 			$(this).find('.accordion-titel').addClass('fa-minus');
  // 		} else {
  // 			$(this).next().slideUp();
  // 			$(this).find('.accordion-titel').addClass('fa-plus');
  // 		}
  // 	});
  // });
  
   $('.accordion-item').on('click', '.accordion-titel', function() {
  
      $('.accordion-contant').slideUp();
  
      if($(this).hasClass('active')){
          $(this).next().slideUp();
          $(this).removeClass('active');
      }
      else{
          $(this).next().slideDown();
          $('.accordion-titel').removeClass('active');
          $(this).addClass('active');
      }
  });
  
    // $(document).ready(function() {
    //   $.fancybox.open({
    //   type: "inline",
    //   touch: false            
    // });
  //});
  
   
    $(document).ready(function() {
      $('.f-button').click(function() {
          $.magnificPopup.close();
      });
  });
  //   jQuery('#sign-up').fancybox({
  //     mobile: {
  //            clickSlide: false,
  //             touch: false
  //         },
  // });
  //  $(':button').click(function() {
  //     parent.$.fancybox.close();
  // })
  
   
  var vids = $("video.video-cont"); 
  $.each(vids, function(){
         this.controls = false; 
  }); 
  
       $(window).scroll(function () {
                  var distance = $(window).scrollTop();
                  $('.categories_row').each(function (i) {
    
                      if ($(this).position().top 
                          <= distance + 350) {
                            
                              $('.cat_img.active').removeClass('active');
    
                              $('.cat_img').eq(i).addClass('active');
                       
                      }
                    
                  });
    
              }).scroll();
  // $(window).load(function(){
  // $('.categories_row .cat_img.active').addClass('active');
  // });
  
    
    

    // Accessibility: fixSlickAccessibility module moved to assets/accessibility-plugin.js (4.7.0).

  })(jQuery);
  
 
  
  $(document).ready(function(){
      /// Main search input
      $('.search-box input[type="text"]').bind('focusin focusout', function(e){
          $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
      });
       
  
      /// Live search
      var preLoadLoadGif = $('<img src="" />');
      var searchTimeoutThrottle = 500;
      var searchTimeoutID = -1;
      var currReqObj = null;
      var $resultsBox = $('<div class="results-box" />').appendTo('.search-box');
      $('.search-box input[type="text"]').bind('keyup change', function(){
       
          //Only search if search string longer than 2, and it has changed
      if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
              //Reset previous value
              $(this).data('oldval', $(this).val());
               console.log('hi');
              // Kill outstanding ajax request
              if(currReqObj != null) currReqObj.abort();
              
              // Kill previous search
              clearTimeout(searchTimeoutID);
            
                var $form = $(this).closest('form');
            
                //Search term
                var term = '*' + $form.find('input[name="q"]').val() + '*';
              
              //URL for full search page
              var linkURL = '/search?&q=' + term;
              
              //Show loading
              $resultsBox.html('<div class="load"></div>');
              
              // Do next search (in X milliseconds)
              searchTimeoutID = setTimeout(function(){
                  //Ajax hit on search page
                  currReqObj = $.ajax({
                    url: $form.attr('action'),
                    data: {
                       view: 'json',
                      q: term,
                    },
                    dataType: "json",
                    success: function(data){
                      console.log(data);
                          currReqObj = null;
                          if(data.results_total == 0) {
                              //No results
                              $resultsBox.html('<div class="note">no search resoults</div>');
                          } else {
                            
                           
                              //Numerous results
                              $resultsBox.empty();
                                $.each(data.results, function(index, item){
                               
  
                                    var $row = $('<a class="'+item.type+'"></a>').attr('href', item.url);
                                    
                                    $row.append('<div class="d-title">'+item.title+'</div>');
                                    $resultsBox.append($row);
                                  
                                  
                                });
                               
                          }
                    }
                  });
              }, searchTimeoutThrottle);
          } else if ($(this).val().length <= 2) {
              //Deleted text? Clear results
              $resultsBox.empty();
          }
      }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
          //Focus, show results
          $resultsBox.fadeIn(200);
      }).bind('click', function(e){
          //Click, prevent body from receiving click event
          e.stopPropagation();
      });
      $('body').bind('click', function(){
          //Click anywhere on page, hide results
          $resultsBox.fadeOut(200);
      });
    
      //Search box should mimic live search string: products only, partial match
      $('.search-form, #search-form').on('submit', function(e){
        e.preventDefault();
      
      });
  
    
      // search ends
  });

$(document).ready(function () {
  // Attach a click event handler to the select element within the specific .item
  $(".item .select-wrp select").on("change", function () {
    // Get the selected value from the select element
    var selectedValue = $(this).val();

    // Find the parent .item and then find retail_prices within that specific item
    var retailPriceshide = $(this).closest(".item").find(".b2b-pr");
var retailPricesshow = $(this).closest(".item").find(".b2b-pr.hid"+selectedValue);
 
    console.log(retailPricesshow);
    // Hide all h5 elements under retail_prices within the specific item
    retailPriceshide.hide();
    retailPricesshow.show();

    // Show the specific h5 element based on the selected value within the specific item
     
  });
});


  $('body').on('click', '.add_to_cart_buttona', function() {
    
    $(this).addClass("active");
    setTimeout(function () {
      $(".add_to_cart_buttona").removeClass("active");
    }, 600);
  });


   
       $('body').on('click', '.bakctotop', function() {
      $(window).scrollTop(0);
});      
function debounce(func, timeout = 500){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
function saveInput(){
  console.log('Saving data');
}

const processChange = debounce(() => saveInput());

// Sidebar product search sits inside #collection-filters-sidebar-form; Enter would submit the whole form.
// Live search uses keyup + AJAX only — stop Enter on this input only (not header search / nav).
$(document).on('keydown', '.qucik-order-search input[name="q"]', function (e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    e.preventDefault();
  }
});

$('.qucik-order-search input[name="q"]').keyup(function(){
  if($(this).val().length === 0 || $(this).val().length === 1){
        $('.maindef').show();
     $('#Search__Results_quick').hide();
    $('div#AjaxinatePagination').show();
     $('div#AjaxinatePaginationa').hide();
       var oaa = $('body').find(".reapro").html();
                     $(".quick-btn h2").html(oaa);
  }
    if($(this).val().length > 1){
  var url = window.location.search.replace('&q=','').replace('q=red&type=product&','');
  console.log(url);
   $.ajax({
                    type: 'GET',
                    url: '/search?section_id=quick_search&q=' + $(this).val()  + '&type=product&options[prefix]=last',
                    success: function(data) {
                     $(document).mouseup(function(e) 
  {
      var container = $(".Collapsible");
  
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
        $('.Collapsible').removeClass('active');
         $('.collapse-headers').removeClass("active");
            $('body').removeClass("activew");
      }
  });

       
          
                 
                     $('#Search__Results_quick').html(data);
                       
                      var ea = $(data);
var ia = $("<div>").append(ea);
                      var oa = ia.find(".searcount").html();
                     $(".quick-btn h2").html(oa+' Products');
                      $('.maindef').hide();
                      $('div#AjaxinatePagination').hide();
                       $('#Search__Results_quick').show();
                       $('div#AjaxinatePaginationa').show();
                                       const createSVG = (width, height, radius) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  
    const rectangle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );
  
    svg.setAttributeNS(
      "http://www.w3.org/2000/svg",
      "viewBox",
      `0 0 ${width} ${height}`
    );
  
    rectangle.setAttribute("x", "0");
    rectangle.setAttribute("y", "0");
    rectangle.setAttribute("width", "100%");
    rectangle.setAttribute("height", "100%");
    rectangle.setAttribute("rx", `${radius}`);
    rectangle.setAttribute("ry", `${radius}`);
    rectangle.setAttribute("pathLength", "10");
  
    svg.appendChild(rectangle);
  
    return svg;
  };
  
  document.querySelectorAll("#Search__Results_quick .btn-primary").forEach((button) => {
    const style = getComputedStyle(button);
  
    const lines = document.createElement("div");
  
    lines.classList.add("lines");
  
    const groupTop = document.createElement("div");
    const groupBottom = document.createElement("div");
  
    const svg = createSVG(
      button.offsetWidth,
      button.offsetHeight,
      parseInt(style.borderRadius, 10)
    );
  
    groupTop.appendChild(svg);
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
  
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
  
    lines.appendChild(groupTop);
    lines.appendChild(groupBottom);
  
    button.appendChild(lines);
  
    button.addEventListener("pointerenter", () => {
      button.classList.add("start");
    });
  
    svg.addEventListener("animationend", () => {
      button.classList.remove("start");
    });
  });
                       if ($(window).width() < 992) {
  $('.quick-product').click(function(){
    $(this).next('.show-tab').toggle(500);
    $(this).toggleClass('open');
  })

    

    }
                           
     $('.bakctotop').on("click",function(){
      $(window).scrollTop(0);
});   
                    }
    });
            }
});



$(document).ready(function() {
 
  $('.qucik-order-search input[name="q"]').on('input', function() {
    if ($(this).val().length > 1) {
       $('.close-c').css('opacity', '1');
    } else {
       $('.close-c').css('opacity', '0');
    }
  });
 
  $('.close-c').on("click",function(){
   
    $('.qucik-order-search input[name="q"]').val("");
    $(this).css('opacity', '0');
        $('.maindef').show();
    $('div#AjaxinatePagination').show();
     $('div#AjaxinatePaginationa').hide();
    $('#Search__Results_quick').hide();
    
       var oaa = $('body').find(".reapro").html();
                     $(".quick-btn h2").html(oaa);
    });
});

 $(document).mouseup(function(e) 
  {
      var containers = $('.qucik-order-search input[name="q"]');
  
      if (!containers.is(e.target) && containers.has(e.target).length === 0) 
      {
          $('.close-c').css('opacity', '0');
            $('body').removeClass("activew");
      }
  });
 
$('.qucik-order-search input[name="q"]').focusout(function(){
  if($(this).val().length === 0){
    $('.maindef').show();
     $('#Search__Results_quick').hide();
    $('div#AjaxinatePagination').show();
     $('div#AjaxinatePaginationa').hide();
       var oaa = $('body').find(".reapro").html();
                     $(".quick-btn h2").html(oaa);
  }
});
$( document ).ready(function() {
  $(".mobveafromhere").detach().appendTo('.dttachagai');
  
});



 $(".btn").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".btn").removeClass("active");
    }, 1000);
  });
 
   $('body').on('click', '.backtip', function() {
     var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
     if(isMobile)
     {
       window.scroll({top: 1300, behavior: "smooth"})
     }
     else
     {
        window.scroll({top: 1200, behavior: "smooth"})
     }

 });
$('body').on('click', '.backtip-terplandia', function() {
     var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
     if(isMobile)
     {
       window.scroll({top: 978, behavior: "smooth"})
     }
     else
     {
        window.scroll({top: 878, behavior: "smooth"})
     }

 });

$('body').on('click', '.backtip-shopby', function () {
  var isMobile = false; //initiate as false
  // device detection
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
  }
  if (isMobile) {
    window.scroll({ top: 708, behavior: "smooth" })
  }
  else {
    window.scroll({ top: 628, behavior: "smooth" })
  }

});

$('body').on('click', '.scroll-down > img', function () {
  var isMobile = false; //initiate as false
  // device detection
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
  }
  if (isMobile) {
    window.scroll({ top: 728, behavior: "smooth" })
  }
  else {
    window.scroll({ top: 628, behavior: "smooth" })
  }

});

$('body').on('click', '.learnmore-terplandia', function() {
     var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
     if(isMobile)
     {
       window.scroll({top: 2902, behavior: "smooth"})
     }
     else
     {
        window.scroll({top: 1972, behavior: "smooth"})
     }

 });

$('body').on('click', '.learnmore-terplandia-product', function() {
     var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
     if(isMobile)
     {
       window.scroll({top: 940, behavior: "smooth"})
     }
     else
     {
        window.scroll({top: 840, behavior: "smooth"})
     }

 });

// window.addEventListener('scroll', () => {
//   console.log('Scroll position:', window.scrollY);
// });


$('.gellis-pro-slide').slick({
      dots: false,
      infinite: false,
      arrows:true,
      speed: 300,
         centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      // prevArrow: $('.prevb'),
      // nextArrow: $('.nextb'),
  prevArrow:"<button type='button' class='prev '><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(1 24.706) rotate(-90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/></g></svg></button>",
  nextArrow:"<button type='button' class='next'><svg xmlns='http://www.w3.org/2000/svg' width='14.06' height='26.121' viewBox='0 0 14.06 26.121'><g id='b' transform='translate(13.06 1.414) rotate(90)'><path id='c' d='M0,11.646,11.646,0,23.292,11.646' transform='translate(0 0)' fill='none' stroke='currentcolor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/> </g> </svg></button>",
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll:3,
          }
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows:false,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            dots: true,
            arrows:false,
            centerPadding: '0px',
            slidesToScroll: 2
          }
        }
      ]
    });
       

document.addEventListener("DOMContentLoaded", function () {
            $(".menu-tooltip span").html(function(_, html) {
                return html.replace("--", "<br>");
            });
        });



$(document).ready(function() {
    let elementsRemoved = false;
    
    function checkWindowSize() {
        const width = $(window).width();
        
        if (width > 450 && elementsRemoved) {
            location.reload();
            elementsRemoved = false;
            return;
        }

        if (width <= 450 && !elementsRemoved) {
            $(".new-1440, .new-768, .new-1919, .new-1920, .wave-d, .main-menu").remove();
            elementsRemoved = true;
        }

        // Handle 430px breakpoint
        if (width <= 430 && width >= 413) {
            $(".new-370, .new-390").remove();
        }
        
        // Handle 400px breakpoint
        if (width <= 412 && width >= 391) {
            $(".new-430, .new-370").remove();
        }
    }

    checkWindowSize();
    $(window).resize(function() {
        checkWindowSize();
    });

});

$(document).on('keydown', '.qty-flex .qty', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
    }
});

// Accessibility: newestTerpenes next-tab helper moved to assets/accessibility-plugin.js (4.7.0).
// Accessibility: keyboard shortcuts module moved to assets/accessibility-plugin.js (4.7.0).